module.exports = __webpack_public_path__ + "static/media/FACADE_009_imaginyou(4).3a433535.jpg";